import React from 'react';
import InputText from './InputText';
import InputNumber from './InputNumber';
import InputCheckbox from './InputCheckbox';
import InputDate from './InputDate';
import InputTextarea from './InputTextarea';
import InputMarkDown from './InputMarkDown';
import InputUrl from './InputUrl';
import InputDateTime from './InputDateTime';
import BannerPlaceTypeSelect from './BannerPlaceTypeSelect';
import { BannerPlaceType, BannerUrlTarget, PromotionPlace, ProductAttributeType, ProductStatus } from '@api/graphql/types';
import BannerUrlTargetSelect from './BannerUrlTargetSelect';
import BannerPlaceSelect from './BannerPlaceSelect';
import PromotionCategorySelect from './PromotionCategorySelect';
import ProductAttributeTypeSelect from './ProductAttributeTypeSelect';
import ProductCategorySelect from './ProductCategorySelect';
import ProductStatusSelect from './ProductStatusSelect';
import FileSelector from './FileSelector';
import InputSelect from './InputSelect';
import InputQuerySelect from './InputQuerySelect';
import ProductListAdTypeSelect from "./ProductListAdTypeSelect";
import UrlsForm from "@modules/ProductListAd/components/UrlsForm";

export type InputTypes = 'text' | 'number' | 'checkbox' | 'date' | 'textarea' | 'markdown' | 'url' | 'datetime' | 'select' | 'queryselect' |
    'bannerplacetype' | 'bannerurltarget' | 'bannerplaceselect' | 'productlistadtype' | 'productlistadurls' | 'promotioncategoryselect' | 'productattributetype' | 'productcategoryselect' |
    'productstatusselect' | 'fileselector' | 'imageselector';

interface PropType {
    type: InputTypes;
    name: string;
    value: string | number | boolean | undefined | string[];
    placeholder?: string;
    hint?: string;
    height?: string;
    step?: string;
    prefix?: string;
    required?: boolean;
    onChange: (value: any, name: string) => void;
    [key: string]: any;
}

const Input = (props: PropType) => {
    const { type, name, value, placeholder, onChange, height, prefix, hint, step, ...otherProps } = props;
    switch (type) {
        case 'number':
            return <InputNumber name={name} value={value ? Number(value) : null} placeholder={placeholder} onChange={onChange} hint={hint} step={(step) ? step : '1'} {...otherProps} />;
        case 'checkbox':
            return <InputCheckbox name={name} value={!!value} placeholder={placeholder} onChangeHandler={onChange} {...otherProps} hint={hint} />;
        case 'date':
            return <InputDate name={name} value={value ? value.toString() : null} placeholder={placeholder} onChange={onChange} hint={hint} {...otherProps} />;
        case 'datetime':
            return <InputDateTime name={name} value={value ? value.toString() : null} placeholder={placeholder} onChange={onChange} hint={hint} {...otherProps} />;
        case 'textarea':
            return <InputTextarea name={name} value={value ? value.toString() : null} placeholder={placeholder} onChangeHandler={onChange} height={height} hint={hint} {...otherProps} />;
        case 'markdown':
            return <InputMarkDown name={name} value={value ? value.toString() : null} placeholder={placeholder} onChangeHandler={onChange} height={height} hint={hint} prefix={prefix} {...otherProps} />;
        case 'url':
            return <InputUrl name={name} value={value ? value.toString() : undefined} placeholder={placeholder} onChangeHandler={onChange} hint={hint} {...otherProps} />;
        case 'select':
            return <InputSelect name={name} value={value ? value.toString() : undefined} placeholder={placeholder} onChangeHandler={onChange} hint={hint} {...otherProps} />;
        case 'queryselect':
            return <InputQuerySelect name={name} value={value ? value.toString() : undefined} placeholder={placeholder} onChangeHandler={onChange} hint={hint} {...otherProps} />;
        case 'bannerplacetype':
            return <BannerPlaceTypeSelect name={name} value={(value as BannerPlaceType)} placeholder={placeholder} onChangeHandler={onChange} hint={hint} {...otherProps} />;
        case 'bannerurltarget':
            return <BannerUrlTargetSelect name={name} value={(value as BannerUrlTarget)} placeholder={placeholder} onChangeHandler={onChange} hint={hint} {...otherProps} />;
        case 'bannerplaceselect':
            return <BannerPlaceSelect name={name} value={(value as string[])} placeholder={placeholder} onChangeHandler={onChange} hint={hint} {...otherProps} />;
        case 'productlistadtype':
            return <ProductListAdTypeSelect name={name} value={(value as string[])} placeholder={placeholder} onChangeHandler={onChange} hint={hint} {...otherProps} />;
        case 'productlistadurls':
            return <UrlsForm name={name} value={value} onChange={onChange} {...otherProps} />;
        case 'promotioncategoryselect':
            return <PromotionCategorySelect name={name} value={(value as PromotionPlace)} placeholder={placeholder} onChangeHandler={onChange} hint={hint} {...otherProps} />;
        case 'productattributetype':
            return <ProductAttributeTypeSelect name={name} value={(value as ProductAttributeType)} placeholder={placeholder} onChangeHandler={onChange} hint={hint} {...otherProps} />;
        case 'productcategoryselect':
            return <ProductCategorySelect name={name} value={(value as ProductAttributeType)} placeholder={placeholder} onChangeHandler={onChange} hint={hint} {...otherProps} />;
        case 'productstatusselect':
            return <ProductStatusSelect name={name} value={(value as ProductStatus)} placeholder={placeholder} onChangeHandler={onChange} hint={hint} {...otherProps} />;
        case 'fileselector':
            return <FileSelector type="file" name={name} value={(value as string)} placeholder={placeholder} onChangeHandler={onChange} hint={hint} prefix={prefix} {...otherProps} />;
        case 'imageselector':
            return <FileSelector type="image" name={name} value={(value as string)} placeholder={placeholder} onChangeHandler={onChange} hint={hint} prefix={prefix} {...otherProps} />;

        case 'text':
        default:
            return <InputText name={name} value={value ? value.toString() : undefined} hint={hint} placeholder={placeholder} onChangeHandler={onChange} {...otherProps} />;
    }
};

export default Input;




// WEBPACK FOOTER //
// ./src/components/Form/Input.tsx